"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListField = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
const register_1 = require("../../register");
const ListField = (field) => {
    const fieldTyped = field;
    const serializer = {
        serialize: (value, buf) => {
            const buf2 = Buffer.alloc(4);
            buf2.writeUInt32BE(value.length);
            let buf3 = Buffer.from([]);
            for (let i = 0; i < value.length; ++i) {
                const item = value[i];
                buf3 = fieldTyped.__serializer__.serialize(item, buf3);
            }
            return Buffer.concat([buf, buf2, buf3]);
        },
        deserialize: (buf) => {
            if (buf.length < 4)
                throw new Error();
            const size = buf.readUInt32BE();
            buf = buf.slice(4);
            const arr = [];
            for (let i = 0; i < size; ++i) {
                const deserializationResult = fieldTyped.__serializer__.deserialize(buf);
                const deserializedObj = deserializationResult[0];
                buf = deserializationResult[1];
                if (buf.length === 0 && i !== size - 1)
                    throw new Error();
                arr.push(deserializedObj);
            }
            return [arr, buf];
        },
    };
    return (0, register_1.buildField)(serializer)();
};
exports.ListField = ListField;
//# sourceMappingURL=list.js.map